import { Close } from "@mui/icons-material";
import { Box, DialogContent, DialogTitle, Divider, IconButton } from "@mui/material";

interface IDialogInnerProps {
  id: string;
  title: string;
  children: React.ReactNode;
  handleClearDialog?: () => void;
}

export default function DialogInner({ id, title, children, handleClearDialog }: IDialogInnerProps) {
  return (
    <>
      <DialogTitle data-test={`${id}-title`}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <span id={`${id}-label`}>{title}</span>
          {handleClearDialog && (
            <IconButton data-test={`${id}-cancel`} aria-label="Close Dialog" onClick={handleClearDialog}>
              <Close />
            </IconButton>
          )}
        </Box>
      </DialogTitle>
      <Divider sx={{ maxWidth: "calc(100% - 48px)", mx: "auto", my: 0, width: 1 }} />
      <DialogContent sx={{ pt: "1rem" }}>{children}</DialogContent>
    </>
  );
}
